/**
 * Single source of truth for author info (Sarai Núñez).
 * Used by all author bylines, the /sobre-sarai page, schema.org Person, etc.
 */
export const AUTHOR = {
  name: "Sarai Núñez",
  fullName: "Sarai Núñez Mendoza",
  role: "Distribuidora Independiente Immunotec",
  shortBio:
    "Creyente, esposa, mamá de 5 hijos, empresaria y ex-nadadora de alto rendimiento. Licenciada en Sistemas Computacionales de profesión y apasionada por la medicina funcional y la longevidad celular. Ayuda a personas desde la bella ciudad de Aguascalientes, México a recuperar energía y vitalidad mediante protocolos personalizados de suplementación.",
  longBio: `Creyente, esposa, mamá de 5 hijos, empresaria y ex-nadadora de alto rendimiento.
Licenciada en Sistemas Computacionales de profesión y apasionada por la medicina
funcional y la longevidad celular.

Ayudo a personas desde la bella ciudad de Aguascalientes, México a recuperar energía
y vitalidad mediante protocolos personalizados de suplementación con productos
respaldados por décadas de investigación científica.`,
  expertise: [
    "Medicina funcional",
    "Suplementación dirigida (Immunotec)",
    "Sistema inmunológico y glutatión",
    "Longevidad celular",
    "Hábitos sostenibles y biohacking",
  ],
  location: "Aguascalientes, México",
  whatsapp: "+521449958252",
  email: "sarai@elioralongevity.com",
};

export const AUTHOR_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": "https://elioralongevity.com/sobre-sarai#person",
  name: AUTHOR.fullName,
  givenName: "Sarai",
  familyName: "Núñez Mendoza",
  jobTitle: AUTHOR.role,
  description: AUTHOR.shortBio,
  url: "https://elioralongevity.com/sobre-sarai",
  email: AUTHOR.email,
  worksFor: { "@type": "Organization", name: "Eliora Longevity" },
  knowsAbout: AUTHOR.expertise,
  address: {
    "@type": "PostalAddress",
    addressLocality: "Aguascalientes",
    addressCountry: "MX",
  },
  alumniOf: {
    "@type": "EducationalOrganization",
    name: "Licenciatura en Sistemas Computacionales",
  },
};
